// Theme is the first slice of app state to move out of the DOM and into the
// store (M1 Phase 2). These helpers keep the store itself pure: the store holds
// the value; these read the initial value from the page and apply changes back
// to it — exactly the way the legacy app did, so nothing visual changes.

export type Theme = "dark" | "light";

// Same key the legacy toggle and the anti-flash inline script in index.html use.
const STORAGE_KEY = "bento-theme";

// Dark is the default (no attribute); light is opt-in via data-theme="light".
// Seed from what the anti-flash script already put on <html> so the store
// starts in sync with the already-painted page.
export function readInitialTheme(): Theme {
  return document.documentElement.getAttribute("data-theme") === "light"
    ? "light"
    : "dark";
}

// Reflect the theme onto the document and persist it — identical DOM shape and
// localStorage key to the legacy code, so the visual result is unchanged.
export function applyTheme(theme: Theme): void {
  const html = document.documentElement;
  if (theme === "light") {
    html.setAttribute("data-theme", "light");
  } else {
    html.removeAttribute("data-theme");
  }
  localStorage.setItem(STORAGE_KEY, theme);
}
